module.exports = __webpack_public_path__ + "static/img/authInstructions_qr.67f59a87.png";